
export function request(method, uri, data, responseType = null, timeout) {
    const xhr = new XMLHttpRequest();
    return [ xhr, new Promise((resolve, reject) => {
        xhr.open(method, uri);
        let _timeout;
        xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300)
                resolve(xhr.response);
            else
                reject(xhr.response);
            clearTimeout(_timeout);
        };
        xhr.onerror = () => reject(xhr.response || "unknown error");
        xhr.onabort = () => reject("abort");
        if (responseType) xhr.responseType = responseType;
        if (timeout)
            _timeout = setTimeout(() => {
                reject("timeout");
                xhr.onabort = undefined;
                xhr.abort();
            }, timeout);
        xhr.send(data);
    }) ];
}

export function newImageBitmap(image) {
    return createImageBitmap(image, { premultiplyAlpha: "none" });
}

export function getTextureData(canvas, filetype, width, height, nb_components, image, aimage) {

    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext("2d", {
        willReadFrequently: true,
    });
    ctx.globalCompositeOperation = "copy";

    ctx.drawImage(image, 0, 0);
    let data = ctx.getImageData(0, 0, width, height).data;

    if (aimage) {
        ctx.drawImage(aimage, 0, 0);
        var adata = ctx.getImageData(0, 0, width, height).data;
        for (var i = 0; i < width * height; i++)
            data[i*4 + 3] = adata[i*4];
    } else if (nb_components == 1 || nb_components == 2) {
        var adata = new Uint8Array(width*height*nb_components);
        if (nb_components == 2 && (
            filetype === 'png' // we use PNG_COLOR_TYPE_GRAY_ALPHA for encoding 2 components png images
            || filetype === 'avif'
        ))
            for (var i = 0; i < width * height; i++) {
                adata[i*2] = data[i*4];
                adata[i*2+1] = data[i*4+3];
            }
        else
            for (var i = 0; i < width * height; i++)
                for (var j = 0; j < nb_components; j++)
                    adata[i*nb_components+j] = data[i*4+j];
        data = adata;
    }

    data.fromGetTextureData = true;
    return data;
}

export function copyBuffer(src) {
    const copy = new src.constructor(new ArrayBuffer(src.byteLength));
    copy.set(src);
    return copy;
}

export function debounce(func, timeout) {
    var timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

export function setLoadingId(url) {
    const u = new URL(url);
    if (!window.n2iLoadingId)
        window.n2iLoadingId = (typeof crypto !== "undefined" && crypto.randomUUID) ? crypto.randomUUID() : Math.random().toString(16).slice(2);
    u.searchParams.set("loadingId", n2iLoadingId);
    return u.href;
}
